import { Typography } from "@mui/material";

import { useSchedule } from "../../../../../hooks/useSchedule";
import { RecentAppointmentItem } from "./RecentAppointmentItem";

export function RecentTrainingEvents() {
	const { recentSchedulers } = useSchedule();

	if (recentSchedulers.length === 0) {
		return null;
	}

	return (
		<div className="section-separator">
			<Typography className="small-title-text bold">
				Recent Training Events
			</Typography>
			<div className="recent-appointments-container item-separator-tiny">
				{recentSchedulers.map((recentScheduler) => (
					<RecentAppointmentItem
						recentAppointment={recentScheduler}
						key={recentScheduler.id}
					/>
				))}
			</div>
		</div>
	);
}
